var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "nk-block-head nk-block-head-sm" }, [
      _c("div", { staticClass: "nk-block-between" }, [
        _c("div", { staticClass: "nk-block-head-content" }, [
          _c("h3", { staticClass: "nk-block-title page-title" }, [
            _vm._v(_vm._s(_vm.trans("configuration.payment_configuration"))),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "nk-block-des text-soft" }, [
            _c("p", [
              _vm._v(_vm._s(_vm.trans("configuration.payment_configuration"))),
            ]),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "admin-config-layout admin-linear-page" },
      [
        _c("configuration-sidebar", { attrs: { menu: "payment" } }),
        _vm._v(" "),
        _c("div", { staticClass: "admin-config-panel" }, [
          _c(
            "div",
            {
              staticClass:
                "admin-config-panel__inner admin-config-panel__inner--wide",
            },
            [
              _c("div", { staticClass: "admin-linear-head" }, [
                _c("div", [
                  _c("span", { staticClass: "admin-linear-head__eyebrow" }, [
                    _vm._v("Payment settings"),
                  ]),
                  _vm._v(" "),
                  _c("h4", { staticClass: "admin-linear-head__title" }, [
                    _vm._v(
                      _vm._s(_vm.trans("configuration.payment_configuration"))
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "admin-linear-head__description" }, [
                    _vm._v(
                      "Enable subscription gateways, configure credentials, and maintain invoice numbering from one guarded settings flow."
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "admin-linear-stats" }, [
                  _c("div", [
                    _c("span", [_vm._v("Gateways")]),
                    _vm._v(" "),
                    _c("strong", [
                      _vm._v(_vm._s(_vm.enabledGatewayCount) + "/4"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.trans("configuration.invoice_configuration"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("strong", [
                      _vm._v(
                        _vm._s(
                          _vm.configForm.subscription_invoice_prefix || "-"
                        )
                      ),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "form",
                {
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.submit.apply(null, arguments)
                    },
                    keydown: function ($event) {
                      return _vm.configForm.errors.clear($event.target.name)
                    },
                  },
                },
                [
                  _c(
                    "section",
                    {
                      staticClass: "admin-config-section",
                      attrs: {
                        "aria-label": _vm.trans(
                          "configuration.payment_configuration"
                        ),
                      },
                    },
                    [
                      _c("div", { staticClass: "admin-linear-section-label" }, [
                        _vm._v("Gateway command"),
                      ]),
                      _vm._v(" "),
                      _c("h4", { staticClass: "admin-config-section__title" }, [
                        _vm._v(
                          _vm._s(
                            _vm.trans("configuration.payment_configuration")
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "p",
                        { staticClass: "admin-config-section__description" },
                        [
                          _vm._v(
                            "Enable only the gateways you operate. Client secrets and private keys should match the selected live or test mode."
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "row admin-linear-gateway-grid" },
                        [
                          _c(
                            "div",
                            { staticClass: "col-12 col-lg-6 col-xl-3" },
                            [
                              _c(
                                "div",
                                { staticClass: "admin-linear-gateway-card" },
                                [
                                  _c("div", { staticClass: "form-group" }, [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("Paypal"),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      [
                                        _c("switches", {
                                          attrs: {
                                            name: "subscription_paypal",
                                            theme: "bootstrap",
                                            color: "success",
                                          },
                                          model: {
                                            value:
                                              _vm.configForm
                                                .subscription_paypal,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.configForm,
                                                "subscription_paypal",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "configForm.subscription_paypal",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _vm.configForm.subscription_paypal
                                    ? _c("div", [
                                        _c(
                                          "div",
                                          { staticClass: "form-group" },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "" } },
                                              [_vm._v("Paypal Mode")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              [
                                                _c("switches", {
                                                  attrs: {
                                                    name: "subscription_paypal_mode",
                                                    theme: "bootstrap",
                                                    color: "success",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.configForm
                                                        .subscription_paypal_mode,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.configForm,
                                                        "subscription_paypal_mode",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "configForm.subscription_paypal_mode",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "form-group" },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "" } },
                                              [_vm._v("Paypal Client Id")]
                                            ),
                                            _vm._v(" "),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.configForm
                                                      .subscription_paypal_client_id,
                                                  expression:
                                                    "configForm.subscription_paypal_client_id",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                type: "text",
                                                name: "subscription_paypal_client_id",
                                                placeholder: "Paypal Client Id",
                                              },
                                              domProps: {
                                                value:
                                                  _vm.configForm
                                                    .subscription_paypal_client_id,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.configForm,
                                                    "subscription_paypal_client_id",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("show-error", {
                                              attrs: {
                                                "form-name": _vm.configForm,
                                                "prop-name":
                                                  "subscription_paypal_client_id",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "form-group" },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "" } },
                                              [_vm._v("Paypal Client Secret")]
                                            ),
                                            _vm._v(" "),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.configForm
                                                      .subscription_paypal_client_secret,
                                                  expression:
                                                    "configForm.subscription_paypal_client_secret",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                type: "text",
                                                name: "subscription_paypal_client_secret",
                                                placeholder:
                                                  "Paypal Client Secret",
                                              },
                                              domProps: {
                                                value:
                                                  _vm.configForm
                                                    .subscription_paypal_client_secret,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.configForm,
                                                    "subscription_paypal_client_secret",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("show-error", {
                                              attrs: {
                                                "form-name": _vm.configForm,
                                                "prop-name":
                                                  "subscription_paypal_client_secret",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-12 col-lg-6 col-xl-3" },
                            [
                              _c(
                                "div",
                                { staticClass: "admin-linear-gateway-card" },
                                [
                                  _c("div", { staticClass: "form-group" }, [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("Stripe"),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      [
                                        _c("switches", {
                                          attrs: {
                                            name: "subscription_stripe",
                                            theme: "bootstrap",
                                            color: "success",
                                          },
                                          model: {
                                            value:
                                              _vm.configForm
                                                .subscription_stripe,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.configForm,
                                                "subscription_stripe",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "configForm.subscription_stripe",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _vm.configForm.subscription_stripe
                                    ? _c("div", [
                                        _c(
                                          "div",
                                          { staticClass: "form-group" },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "" } },
                                              [_vm._v("Stripe Mode")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              [
                                                _c("switches", {
                                                  attrs: {
                                                    name: "subscription_stripe_mode",
                                                    theme: "bootstrap",
                                                    color: "success",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.configForm
                                                        .subscription_stripe_mode,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.configForm,
                                                        "subscription_stripe_mode",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "configForm.subscription_stripe_mode",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "form-group" },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "" } },
                                              [_vm._v("Stripe Publishable Key")]
                                            ),
                                            _vm._v(" "),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.configForm
                                                      .subscription_stripe_publishable_key,
                                                  expression:
                                                    "configForm.subscription_stripe_publishable_key",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                type: "text",
                                                name: "subscription_stripe_publishable_key",
                                                placeholder:
                                                  "Stripe Publishable Key",
                                              },
                                              domProps: {
                                                value:
                                                  _vm.configForm
                                                    .subscription_stripe_publishable_key,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.configForm,
                                                    "subscription_stripe_publishable_key",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("show-error", {
                                              attrs: {
                                                "form-name": _vm.configForm,
                                                "prop-name":
                                                  "subscription_stripe_publishable_key",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "form-group" },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "" } },
                                              [_vm._v("Stripe Private Key")]
                                            ),
                                            _vm._v(" "),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.configForm
                                                      .subscription_stripe_private_key,
                                                  expression:
                                                    "configForm.subscription_stripe_private_key",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                type: "text",
                                                name: "subscription_stripe_private_key",
                                                placeholder:
                                                  "Stripe Private Key",
                                              },
                                              domProps: {
                                                value:
                                                  _vm.configForm
                                                    .subscription_stripe_private_key,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.configForm,
                                                    "subscription_stripe_private_key",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("show-error", {
                                              attrs: {
                                                "form-name": _vm.configForm,
                                                "prop-name":
                                                  "subscription_stripe_private_key",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-12 col-lg-6 col-xl-3" },
                            [
                              _c(
                                "div",
                                { staticClass: "admin-linear-gateway-card" },
                                [
                                  _c("div", { staticClass: "form-group" }, [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("Razorpay"),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      [
                                        _c("switches", {
                                          attrs: {
                                            name: "subscription_razorpay",
                                            theme: "bootstrap",
                                            color: "success",
                                          },
                                          model: {
                                            value:
                                              _vm.configForm
                                                .subscription_razorpay,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.configForm,
                                                "subscription_razorpay",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "configForm.subscription_razorpay",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _vm.configForm.subscription_razorpay
                                    ? _c("div", [
                                        _c(
                                          "div",
                                          { staticClass: "form-group" },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "" } },
                                              [_vm._v("Razorpay Mode")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              [
                                                _c("switches", {
                                                  attrs: {
                                                    name: "subscription_razorpay_mode",
                                                    theme: "bootstrap",
                                                    color: "success",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.configForm
                                                        .subscription_razorpay_mode,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.configForm,
                                                        "subscription_razorpay_mode",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "configForm.subscription_razorpay_mode",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "form-group" },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "" } },
                                              [
                                                _vm._v(
                                                  "Razorpay Publishable Key"
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.configForm
                                                      .subscription_razorpay_publishable_key,
                                                  expression:
                                                    "configForm.subscription_razorpay_publishable_key",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                type: "text",
                                                name: "subscription_razorpay_publishable_key",
                                                placeholder:
                                                  "Razorpay Publishable Key",
                                              },
                                              domProps: {
                                                value:
                                                  _vm.configForm
                                                    .subscription_razorpay_publishable_key,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.configForm,
                                                    "subscription_razorpay_publishable_key",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("show-error", {
                                              attrs: {
                                                "form-name": _vm.configForm,
                                                "prop-name":
                                                  "subscription_razorpay_publishable_key",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "form-group" },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "" } },
                                              [_vm._v("Razorpay Private Key")]
                                            ),
                                            _vm._v(" "),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.configForm
                                                      .subscription_razorpay_private_key,
                                                  expression:
                                                    "configForm.subscription_razorpay_private_key",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                type: "text",
                                                name: "subscription_razorpay_private_key",
                                                placeholder:
                                                  "Razorpay Private Key",
                                              },
                                              domProps: {
                                                value:
                                                  _vm.configForm
                                                    .subscription_razorpay_private_key,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.configForm,
                                                    "subscription_razorpay_private_key",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("show-error", {
                                              attrs: {
                                                "form-name": _vm.configForm,
                                                "prop-name":
                                                  "subscription_razorpay_private_key",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-12 col-lg-6 col-xl-3" },
                            [
                              _c(
                                "div",
                                { staticClass: "admin-linear-gateway-card" },
                                [
                                  _c("div", { staticClass: "form-group" }, [
                                    _c("label", { attrs: { for: "" } }, [
                                      _vm._v("Two Checkout"),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      [
                                        _c("switches", {
                                          attrs: {
                                            name: "subscription_two_checkout",
                                            theme: "bootstrap",
                                            color: "success",
                                          },
                                          model: {
                                            value:
                                              _vm.configForm
                                                .subscription_two_checkout,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.configForm,
                                                "subscription_two_checkout",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "configForm.subscription_two_checkout",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _vm.configForm.subscription_two_checkout
                                    ? _c("div", [
                                        _c(
                                          "div",
                                          { staticClass: "form-group" },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "" } },
                                              [_vm._v("Two Checkout Mode")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              [
                                                _c("switches", {
                                                  attrs: {
                                                    name: "subscription_two_checkout_mode",
                                                    theme: "bootstrap",
                                                    color: "success",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.configForm
                                                        .subscription_two_checkout_mode,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.configForm,
                                                        "subscription_two_checkout_mode",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "configForm.subscription_two_checkout_mode",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "form-group" },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "" } },
                                              [_vm._v("Two Checkout Seller Id")]
                                            ),
                                            _vm._v(" "),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.configForm
                                                      .subscription_two_checkout_seller_id,
                                                  expression:
                                                    "configForm.subscription_two_checkout_seller_id",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                type: "text",
                                                name: "subscription_two_checkout_seller_id",
                                                placeholder:
                                                  "Two Checkout Seller Id",
                                              },
                                              domProps: {
                                                value:
                                                  _vm.configForm
                                                    .subscription_two_checkout_seller_id,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.configForm,
                                                    "subscription_two_checkout_seller_id",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("show-error", {
                                              attrs: {
                                                "form-name": _vm.configForm,
                                                "prop-name":
                                                  "subscription_two_checkout_seller_id",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "form-group" },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "" } },
                                              [
                                                _vm._v(
                                                  "Two Checkout Publishable Key"
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.configForm
                                                      .subscription_two_checkout_publishable_key,
                                                  expression:
                                                    "configForm.subscription_two_checkout_publishable_key",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                type: "text",
                                                name: "subscription_two_checkout_publishable_key",
                                                placeholder:
                                                  "Two Checkout Publishable Key",
                                              },
                                              domProps: {
                                                value:
                                                  _vm.configForm
                                                    .subscription_two_checkout_publishable_key,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.configForm,
                                                    "subscription_two_checkout_publishable_key",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("show-error", {
                                              attrs: {
                                                "form-name": _vm.configForm,
                                                "prop-name":
                                                  "subscription_two_checkout_publishable_key",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "form-group" },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "" } },
                                              [
                                                _vm._v(
                                                  "Two Checkout Private Key"
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.configForm
                                                      .subscription_two_checkout_private_key,
                                                  expression:
                                                    "configForm.subscription_two_checkout_private_key",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                type: "text",
                                                name: "subscription_two_checkout_private_key",
                                                placeholder:
                                                  "Two Checkout Private Key",
                                              },
                                              domProps: {
                                                value:
                                                  _vm.configForm
                                                    .subscription_two_checkout_private_key,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.configForm,
                                                    "subscription_two_checkout_private_key",
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("show-error", {
                                              attrs: {
                                                "form-name": _vm.configForm,
                                                "prop-name":
                                                  "subscription_two_checkout_private_key",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "section",
                    {
                      staticClass: "admin-config-section",
                      attrs: {
                        "aria-label": _vm.trans(
                          "configuration.invoice_configuration"
                        ),
                      },
                    },
                    [
                      _c("div", { staticClass: "admin-linear-section-label" }, [
                        _vm._v("Invoice command"),
                      ]),
                      _vm._v(" "),
                      _c("h4", { staticClass: "admin-config-section__title" }, [
                        _vm._v(
                          _vm._s(
                            _vm.trans("configuration.invoice_configuration")
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "p",
                        { staticClass: "admin-config-section__description" },
                        [
                          _vm._v(
                            "Invoice numbering affects new subscription invoices and should be changed with care."
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-12 col-sm-4" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.trans(
                                      "configuration.subscription_invoice_prefix"
                                    )
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.configForm
                                        .subscription_invoice_prefix,
                                    expression:
                                      "configForm.subscription_invoice_prefix",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  name: "subscription_invoice_prefix",
                                  placeholder: _vm.trans(
                                    "configuration.subscription_invoice_prefix"
                                  ),
                                },
                                domProps: {
                                  value:
                                    _vm.configForm.subscription_invoice_prefix,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.configForm,
                                      "subscription_invoice_prefix",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("show-error", {
                                attrs: {
                                  "form-name": _vm.configForm,
                                  "prop-name": "subscription_invoice_prefix",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-12 col-sm-4" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.trans(
                                      "configuration.subscription_invoice_number_digit"
                                    )
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.configForm
                                        .subscription_invoice_number_digit,
                                    expression:
                                      "configForm.subscription_invoice_number_digit",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  name: "subscription_invoice_number_digit",
                                  placeholder: _vm.trans(
                                    "configuration.subscription_invoice_number_digit"
                                  ),
                                },
                                domProps: {
                                  value:
                                    _vm.configForm
                                      .subscription_invoice_number_digit,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.configForm,
                                      "subscription_invoice_number_digit",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("show-error", {
                                attrs: {
                                  "form-name": _vm.configForm,
                                  "prop-name":
                                    "subscription_invoice_number_digit",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-12 col-sm-4" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.trans(
                                      "configuration.subscription_invoice_start_number"
                                    )
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.configForm
                                        .subscription_invoice_start_number,
                                    expression:
                                      "configForm.subscription_invoice_start_number",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  name: "subscription_invoice_start_number",
                                  placeholder: _vm.trans(
                                    "configuration.subscription_invoice_start_number"
                                  ),
                                },
                                domProps: {
                                  value:
                                    _vm.configForm
                                      .subscription_invoice_start_number,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.configForm,
                                      "subscription_invoice_start_number",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("show-error", {
                                attrs: {
                                  "form-name": _vm.configForm,
                                  "prop-name":
                                    "subscription_invoice_start_number",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.trans(
                                  "configuration.subscription_invoice_tnc"
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("html-editor", {
                            attrs: {
                              name: "subscription_invoice_tnc",
                              model: _vm.configForm.subscription_invoice_tnc,
                              isUpdate: _vm.updateTnc,
                            },
                            on: {
                              "update:model": function ($event) {
                                return _vm.$set(
                                  _vm.configForm,
                                  "subscription_invoice_tnc",
                                  $event
                                )
                              },
                              clearErrors: function ($event) {
                                return _vm.configForm.errors.clear(
                                  "subscription_invoice_tnc"
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("show-error", {
                            attrs: {
                              "form-name": _vm.configForm,
                              "prop-name": "subscription_invoice_tnc",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "admin-config-actions" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid",
                        attrs: { type: "submit" },
                      },
                      [_vm._v(_vm._s(_vm.trans("general.save")))]
                    ),
                  ]),
                ]
              ),
            ]
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }